/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentUploadResponseDto } from '../../models/attachment-upload-response-dto';

export interface DynamicApplicationsIdAttachmentsPost$Params {
  id: number;
  body?: {
    'attachments'?: Array<Blob>;
  };
}

export function dynamicApplicationsIdAttachmentsPost(
  http: HttpClient,
  rootUrl: string,
  params: DynamicApplicationsIdAttachmentsPost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AttachmentUploadResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, dynamicApplicationsIdAttachmentsPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttachmentUploadResponseDto>>;
    }),
  );
}

dynamicApplicationsIdAttachmentsPost.PATH = '/dynamic/applications/{id}/attachments';
